<template>
    <div id="simple-calendar-app">
        <div class="vx-card no-scroll-content" style="min-height: 800px">
            <calendar-view
                    ref="calendar"
                    :displayPeriodUom="calendarView"
                    :show-date="showDate"
                    :events="calendarEvents"
                    :displayPeriodCount="2"
                    :startingDayOfWeek="1"
                    :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
                    eventBorderHeight="0px"
                    @click-event="openEventEdit"
                    eventContentHeight="1.65rem"
                    class="theme-default">

                <div slot="header" class="mb-4">

                    <div class="vx-row no-gutter">

                        <div class="vx-col w-1/3 items-center sm:flex hidden">
                            <!-- Add new event button -->
                            <vs-button v-if="this.$checkPermission(1801)" icon-pack="feather" icon="icon-plus" @click="addNewEventPromptOpen = true">{{$t('Add')}}</vs-button>
                        </div>

                        <!-- Current Month -->
                        <div class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex sm:justify-end justify-center order-last">
                            <div class="flex items-center">
                                <feather-icon
                                        :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                                        @click="updateMonth(-1)"
                                        svgClasses="w-5 h-5 m-1"
                                        class="cursor-pointer bg-primary text-white rounded-full" />

                                <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDate | month }}</span>

                                <feather-icon
                                        :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                                        @click="updateMonth(1)"
                                        svgClasses="w-5 h-5 m-1"
                                        class="cursor-pointer bg-primary text-white rounded-full" />
                            </div>
                        </div>

                        <div class="vx-col sm:w-1/3 w-full flex justify-center">
                            <template v-for="(view, index) in calendarViewTypes">
                                <vs-button
                                        v-if="calendarView === view.val"
                                        :key="String(view.val) + 'filled'"
                                        type="filled"
                                        class="p-3 md:px-8 md:py-3"
                                        :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                                        @click="calendarView = view.val"
                                >{{ view.label }}</vs-button>
                                <vs-button
                                        v-else
                                        :key="String(view.val) + 'border'"
                                        type="border"
                                        class="p-3 md:px-8 md:py-3"
                                        :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                                        @click="calendarView = view.val"
                                >{{ view.label }}</vs-button>
                            </template>

                        </div>
                    </div>
                </div>
            </calendar-view>
        </div>

        <vs-popup :title="$t('Add')" :active.sync="addNewEventPromptOpen">
            <p class="mt-6">{{$t("StartTime")}}</p>
            <flat-pickr class="w-full" :config="configDateTimePicker" v-model="addEventStartTime"/>
            <p class="mt-6">{{$t("EndTime")}}</p>
            <flat-pickr class="w-full" :config="configDateTimePicker" v-model="addEventEndTime"/>
            <p class="mt-6">{{$t("User")}}</p>
            <vs-select class="w-full" autocomplete v-model="addEventUser">
                <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in $store.getters.companyUsers" />
            </vs-select>

            <vs-divider/>

            <vs-button id="newEventButton" color="success" class="mt-6; mr-1" @click="addEvent">{{$t("Add")}}</vs-button>


        </vs-popup>

        <vs-popup :title="$t('Edit')" :active.sync="editEventPromptOpen">
            <p class="mt-6">{{$t("StartTime")}}</p>
            <flat-pickr class="w-full" :config="configDateTimePicker" v-model="editEventStartTime"/>
            <p class="mt-6">{{$t("EndTime")}}</p>
            <flat-pickr class="w-full" :config="configDateTimePicker" v-model="editEventEndTime"/>
            <p class="mt-6">{{$t("User")}}</p>
            <vs-select class="w-full" autocomplete v-model="editEventUser">
                <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in $store.getters.companyUsers" />
            </vs-select>

            <vs-divider/>

            <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editEvent">{{$t("Change")}}</vs-button>
            <vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeEvent">{{$t("Delete")}}</vs-button>


        </vs-popup>

    </div>
</template>
<script>

    import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"
    require("vue-simple-calendar/static/css/default.css");
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import { en, he } from "vuejs-datepicker/src/locale"

    export default {
        components: {
            CalendarView,
            CalendarViewHeader,
            flatPickr,
        },
        data() {
            return {
                onCallRaw: undefined,
                showDate: new Date(),
                calendarView: 'week',

                configDateTimePicker: {
                    dateFormat: 'Y-m-d',
                    locale: {
                        firstDayOfWeek: 1
                    }
                },

                addEventStartTime: null,
                addEventEndTime: null,
                addEventUser: 0,

                editEventStartTime: null,
                editEventEndTime: null,
                editEventUser: 0,
                editEventId: 0,

                addNewEventPromptOpen: false,
                editEventPromptOpen: false,

                currentMonthChange: 0,
                currentWeekChange: 0,

                calendarViewTypes: [
                    {
                        label: this.$t("Month"),
                        val: "month"
                    },
                    {
                        label: this.$t("Week"),
                        val: "week"
                    },
                ],
            }
        },
        methods: {
            addEvent(){
                this.$vs.loading({
                    background: "primary",
                    color: "fff",
                    container: "#newEventButton",
                    scale: 0.45
                });

                const thisIns = this;
                this.$http.post('/api/v1/calendar/on_call/', {
                    end_time: thisIns.moment(thisIns.addEventEndTime).format(),
                    start_time: thisIns.moment(thisIns.addEventStartTime).format(),
                    user_id: Number(thisIns.addEventUser),
                }).then(function () {
                    thisIns.updateOnCallData();
                    thisIns.$vs.loading.close("#newEventButton > .con-vs-loading");
                    thisIns.addNewEventPromptOpen = false;
                }).catch(function (error) {
                    thisIns.$vs.loading.close("#newEventButton > .con-vs-loading");
                    thisIns.addNewEventPromptOpen = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            editEvent(){

                const thisIns = this;
                this.$http.put('/api/v1/calendar/on_call/' + this.editEventId, {
                    end_time: thisIns.moment(thisIns.editEventEndTime).format(),
                    start_time: thisIns.moment(thisIns.editEventStartTime).format(),
                    user_id: Number(thisIns.editEventUser),
                }).then(function () {
                    thisIns.updateOnCallData();
                    thisIns.editEventPromptOpen = false;
                }).catch(function (error) {
                    thisIns.editEventPromptOpen = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeEvent(){
                const thisIns = this;
                this.$http.delete('/api/v1/calendar/on_call/' + this.editEventId)
                .then(function () {
                    thisIns.updateOnCallData();
                    thisIns.editEventPromptOpen = false;
                }).catch(function (error) {
                    thisIns.editEventPromptOpen = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            updateOnCallData() {
                const thisIns = this;
                let change = 0;
                if(this.calendarView === 'week'){
                    change = this.currentWeekChange;
                }else{
                    change = this.currentMonthChange;
                }

                this.$http.get('/api/v1/calendar/on_call/' + this.calendarView + '/' + change)
                    .then(function (response) {
                        thisIns.onCallRaw = response.data
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            position:'top-right',
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });


            },
            updateMonth(val) {
                if(this.calendarView === 'week'){
                    this.currentWeekChange += val;
                }else{
                    this.currentMonthChange += val;
                }
                this.updateOnCallData();
                this.showDate = this.$refs.calendar.getIncrementedPeriod(val);
            },
            openEventEdit(date){
                if(!this.$checkPermission(1801)) return;
                this.editEventStartTime = this.onCallRaw[date.id].start_time;
                this.editEventEndTime = this.onCallRaw[date.id].end_time;
                this.editEventUser = this.onCallRaw[date.id].user_id;
                this.editEventId = this.onCallRaw[date.id].on_call_id;
                this.editEventPromptOpen = true;
            }
        },
        computed: {
            windowWidth() {
                return this.$store.state.windowWidth
            },
            calendarEvents() {

                let events = [];

                if(this.onCallRaw) {

                    for(let x = 0; x < this.onCallRaw.length; x++) {
                        events.push({
                            id: x,
                            startDate: this.moment(this.onCallRaw[x].start_time).format("YYYY-MM-DD"),
                            endDate: this.moment(this.onCallRaw[x].end_time).format("YYYY-MM-DD"),
                            title: this.onCallRaw[x].user,
                            classes: 'event-success',
                        });
                    }

                }

                return events
            },
        },
        watch: {
            calendarView(){
                this.currentMonthChange = 0;
                this.currentWeekChange = 0;
                this.showDate = new Date();
                this.updateOnCallData();
            }
        },
        created() {
            this.updateOnCallData();
        }

    }

</script>
<style lang="scss">
    @import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>
